import React, { useEffect, useState } from "react";
import Header from "../Header";
import {
  FetchBatchData,
  FetchPostgreSQLData,
  FetchTotalTaskinCourse
} from "../../api/aws-api";
import { ConstructorEventGet } from "../../Event/event";
import { ClassicSpinner } from "react-spinners-kit";
import { Tooltip } from "react-tooltip";
import {
  CircularProgressbar,
  buildStyles
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const Dashboard = () => {
  const [loading, setLoading] = useState(false);
  const [batchList, setBatchList] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [studentProgress, setStudentProgress] = useState([]);
  const [batchProgress, setBatchProgress] = useState(0);

  useEffect(() => {
    FetchBatchList();
  }, []);

  const FetchBatchList = async () => {
    setLoading(true);
    try {
      const id = JSON.parse(localStorage.getItem("UserKey"))["user_id"];
      const responsedata = await ConstructorEventGet(FetchBatchData, {
        mentorId: id
      });
      setBatchList(responsedata || []);
    } catch (err) {
      console.error("Error fetching batches:", err);
    }
    setLoading(false);
  };

  const handleBatchClick = async (batch) => {
    setLoading(true);
    setSelectedBatch(batch);

    const studentIds =
      batch.StudentsEndrolled?.map((student) => student.key) || [];
    const courseId = batch.courseId;

    try {
      const responsedata = await ConstructorEventGet(
        FetchTotalTaskinCourse,
        { course_id: courseId }
      );
      const parsedBody = JSON.parse(responsedata.body);
      const totalTasks = Number(parsedBody.total_task_ids) || 0;

      let progressData = [];
      let totalProgress = 0;

      for (const user_id of studentIds) {
        try {
          const params = { user_id, course_id: courseId };
          const result = await ConstructorEventGet(FetchPostgreSQLData, params);
          console.log("Result",result)
          const completedCount = Array.isArray(JSON.parse(result.body))
            ? JSON.parse(result.body).length
            : 0;

          // ✅ Prevent NaN by checking totalTasks
          const progressPercent =
            totalTasks > 0
              ? Math.round((completedCount / totalTasks) * 100)
              : 0;

          totalProgress += progressPercent;

          const student = batch.StudentsEndrolled.find(
            (s) => s.key === user_id
          );
          progressData.push({
            name: student?.name || user_id,
            progress: progressPercent
          });
        } catch (error) {
          console.error(`Error fetching data for ${user_id}:`, error);
          progressData.push({
            name: user_id,
            progress: 0
          });
        }
      }

      const avgProgress =
        studentIds.length > 0
          ? Math.round(totalProgress / studentIds.length)
          : 0;

      setStudentProgress(progressData);
      setBatchProgress(avgProgress);
    } catch (err) {
      console.error("Error fetching batch progress:", err);
    }

    setLoading(false);
  };

  return (
    <>
      <Header />
      {loading ? (
        <div className="spinner">
          <div className="spinner-wrapper">
            <ClassicSpinner size={50} color="black" loading={loading} />
          </div>
        </div>
      ) : (
        <div className="section-padding">
          <div className="container">
            <div className="text-center mb-6">
              <div className="mini-title">Batches</div>
              <div className="column-title">
                Choose <span className="shape-bg">Your</span> Batch
              </div>
            </div>

            <div className="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-[30px] pt-10">
              {Array.isArray(batchList) && batchList.length > 0 ? (
                batchList.map((item, index) => (
                  <div
                    key={index}
                    onClick={() => handleBatchClick(item)}
                    className="rounded-[8px] cursor-pointer transition duration-100 hover:shadow-box hover:bg-white group bg-[#FFE8E8] text-center hover:-translate-y-2 pt-4"
                  >
                    <div className="w-[72px] h-[72px] rounded-full bg-white relative mx-auto flex flex-col justify-center items-center mb-8 group-hover:bg-[#FFE8E8]">
                      <iconify-icon
                        icon="mdi:clipboard-text-date"
                        style={{ fontSize: "2em" }}
                      />
                    </div>

                    <Tooltip id={item.BatchId} className="bg-secondary">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column"
                        }}
                      >
                        <p>Students:</p>
                        <br />
                        <ul>
                          {item.StudentsEndrolled?.map((student, idx) => (
                            <li key={idx}>
                              <b>{student.name}</b>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </Tooltip>

                    <div className="course-content">
                      <h4 className="text-2xl mb-2 font-bold">
                        {item.courseName}
                      </h4>
                      <h4 className="text-xl">
                        {item.BatchName?.split("-").pop()}
                      </h4>
                      <p>
                        {item.StartDate} → {item.EndDate}
                      </p>
                      <p>
                        {item.StartTime} → {item.EndTime}
                      </p>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center w-full">
                  No batches available.
                </div>
              )}
            </div>

            {selectedBatch && (
              <div className="mt-10">
                <div className="text-center mb-4">
                  <h2 className="text-2xl font-bold mb-3">
                    Batch Progress
                  </h2>
                  <div
                    style={{
                      width: 100,
                      height: 100,
                      margin: "auto"
                    }}
                  >
                    <CircularProgressbar
                      value={batchProgress}
                      text={`${batchProgress}%`}
                      styles={buildStyles({
                        textColor: "#000",
                        pathColor: "#4caf50",
                        trailColor: "#eee"
                      })}
                    />
                  </div>
                </div>

                <div className="mt-8">
                  <h3 className="text-xl font-semibold mb-4">
                    Student Progress
                  </h3>

                  {studentProgress.map((student, index) => (
                    <div key={index} className="mb-4">
                      <div className="flex justify-between mb-1 text-sm font-medium text-gray-700">
                        <span>{student.name}</span>
                        <span>{student.progress}%</span>
                      </div>
                      <div className="w-full border border-gray-300 rounded-full h-4 relative overflow-hidden">
                        <div
                          className="bg-green-500 h-full"
                          style={{
                            width: `${student.progress}%`
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Dashboard;
